import { contactCategoryDeleteApi } from "../../api/contactCategory/contactCategoryDeleteApi"

type PayloadShape = Parameters<typeof contactCategoryDeleteApi>[0]

export async function contactCategoryDeleteService(payload: PayloadShape, token: string) {
	return await contactCategoryDeleteApi(payload, token)
}
